import { useRouter as useCompatRouter } from 'next/compat/router';

/**
 * TODO: Add a deschription and explain the added value from the use of the next router
 * Potentially mark for removal.
 */
// eslint-disable-next-line sonarjs/cognitive-complexity
export const useRouter = (fallbackLocale = 'nl-BE') => {
  const router = useCompatRouter();
  const routerLocales = router?.locales;

  const locales = routerLocales?.filter(locale => locale !== 'default') || [];

  return {
    asPath: router?.asPath ?? '',
    back: router?.back ?? (() => undefined),
    beforePopState: router?.beforePopState ?? (() => undefined),
    defaultLocale: router?.defaultLocale,
    domainLocales: router?.domainLocales,
    forward: router?.forward ?? (() => undefined),
    isFallback: router?.isFallback ?? false,
    isLocaleDomain: router?.isLocaleDomain ?? false,
    isPreview: router?.isPreview ?? false,
    isReady: router?.isReady ?? false,
    locale: router?.locale || fallbackLocale,
    locales,
    pathname: router?.pathname ?? '',
    prefetch: router?.prefetch ?? (async () => undefined),
    push: router?.push ?? (async () => false),
    query: router?.query ?? {},
    reload: router?.reload ?? (() => undefined),
    replace: router?.replace ?? (async () => false),
    route: router?.route ?? '',
  };
};

export default useRouter;
